import {handleKeyPressEnterOrSpace} from '@wix/panda-js-utils'
import {membersPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import React from 'react'
import {EventLink} from '../../styled-components/event-link'
import {DetailsButtonProps} from './index'

export const DetailsButton = ({mobile, event, navigateToDetailsPage, t}: DetailsButtonProps) => {
  const handleClick = () => navigateToDetailsPage(event)
  return (
    <EventLink
      primary={true}
      mobile={mobile}
      as="a"
      onKeyPress={handleKeyPressEnterOrSpace(handleClick)}
      onClick={handleClick}
      data-hook={DH.BUTTON_GO_TO_DETAILS}
    >
      {t('events.buttons.go-to-details')}
    </EventLink>
  )
}
